import { CLINIC } from "@/lib/api";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0F2C59] text-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="font-display text-2xl font-extrabold">Denti Service</div>
          <p className="text-sm text-white/70 mt-2">Clinică stomatologică în Bacău din 1992.</p>
          <div className="mt-6 space-y-3 text-sm">
            <div className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 shrink-0" /><span>{CLINIC.address}</span></div>
            <div className="flex items-start gap-3"><Phone className="w-4 h-4 mt-0.5 shrink-0" /><a href={CLINIC.phoneTel} className="hover:underline">{CLINIC.phone}</a></div>
            <div className="flex items-start gap-3"><MessageCircle className="w-4 h-4 mt-0.5 shrink-0" /><a href={CLINIC.whatsapp} target="_blank" rel="noreferrer" className="hover:underline">WhatsApp {CLINIC.phone}</a></div>
            <div className="flex items-start gap-3"><Clock className="w-4 h-4 mt-0.5 shrink-0" /><span>{CLINIC.hours}</span></div>
          </div>
        </div>
        <div>
          <h3 className="text-sm font-semibold uppercase tracking-wider text-white/60 mb-4">Navigare</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:underline">Acasă</Link></li>
            <li><Link to="/despre-noi" className="hover:underline">Despre clinică</Link></li>
            <li><Link to="/servicii" className="hover:underline">Servicii</Link></li>
            <li><Link to="/echipa-medicala" className="hover:underline">Echipa</Link></li>
            <li><Link to="/cazuri-tratate" className="hover:underline">Cazuri tratate</Link></li>
            <li><Link to="/blog" className="hover:underline">Articole</Link></li>
            <li><Link to="/pacienti-din-strainatate" className="hover:underline">Pacienți din străinătate</Link></li>
            <li><Link to="/intrebari-frecvente" className="hover:underline">Întrebări frecvente</Link></li>
            <li><Link to="/tarife" className="hover:underline">Tarife</Link></li>
            <li><Link to="/contact" className="hover:underline">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-sm font-semibold uppercase tracking-wider text-white/60 mb-4">Legal</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/politica-de-confidentialitate" className="hover:underline">Politica de confidențialitate</Link></li>
            <li><Link to="/politica-cookies" className="hover:underline">Politica privind cookie-urile</Link></li>
            <li><Link to="/termeni-conditii" className="hover:underline">Termeni și condiții</Link></li>
            <li><Link to="/proiecte-europene" className="hover:underline" data-testid="footer-eu-projects-link">Proiecte cu finanțare europeană</Link></li>
            <li>
              <button
                type="button"
                onClick={() => {
                  try { localStorage.removeItem("ds_cookie_consent"); } catch (e) {}
                  window.dispatchEvent(new Event("ds:cookie-reopen"));
                }}
                className="hover:underline text-left"
                data-testid="footer-cookie-settings-btn"
              >
                Setări cookie
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 text-xs text-white/60 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>© {new Date().getFullYear()} Denti Service SRL. {CLINIC.website}.</div>
          <a
            href="https://reclamatiisal.anpc.ro"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex shrink-0 opacity-90 hover:opacity-100 transition-opacity"
            aria-label="Soluționarea alternativă a litigiilor — ANPC SAL"
            data-testid="anpc-sal-link"
          >
            <img
              src="/anpc-sal.png"
              alt="ANPC — Soluționarea Alternativă a Litigiilor (SAL)"
              width="250"
              height="50"
              loading="lazy"
              decoding="async"
              className="block h-[50px] w-[250px]"
            />
          </a>
        </div>
      </div>
    </footer>
  );
}
